import { render, staticRenderFns } from "./AdminLocations.vue?vue&type=template&id=efdbbc20&scoped=true"
import script from "./AdminLocations.vue?vue&type=script&lang=js"
export * from "./AdminLocations.vue?vue&type=script&lang=js"
import style0 from "./AdminLocations.vue?vue&type=style&index=0&id=efdbbc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdbbc20",
  null
  
)

export default component.exports